<template>
  <div class="row">
    <div class="page-title">
      <div class="row">
        <div class="col-sm-6 col-12">
          <h2>
            Shifts Calendar
          </h2>
        </div>
        <div class="col-sm-6 col-12 text-end">
          <a class="btn btn-outline-primary align-items-center me-2" href="/admin/shifts">
            <i class="fas fa-table"></i>
            Table View
          </a>
          <a class="btn btn-primary align-items-center" href="/admin/shifts/new">
            <i class="fa-regular fa-square-plus"></i>
            Add New
          </a>
        </div>
      </div>
    </div>

    <div class="col-xl-12 xl-100 box-col-6">
      <div class="card">
        <div class="card-body">
          <FullCalendar :options="calendarOptions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

const calendarOptions = reactive({
  plugins: [dayGridPlugin, interactionPlugin],
  initialView: 'dayGridMonth',
  height: 'auto',
  events: [],
  eventClick: (info) => {
    window.location.href = `/admin/shifts/${info.event.id}`;
  },
  dateClick: () => {
    window.location.href = '/admin/shifts/new';
  }
});

const fetchShifts = async () => {
  try {
    const response = await fetch('/api/shifts');
    if (!response.ok) return;
    const shifts = await response.json();
    // Strip a possible bracketed IANA zone suffix (e.g. "[America/Toronto]") depending on the
    // server JVM's default timezone — java.time can emit one, FullCalendar's parser does not
    // expect it (#73 pre-commit review).
    const stripZoneId = (value) => (value ? value.replace(/\[[^\]]*\]$/, '') : value);
    calendarOptions.events = shifts.map((shift) => ({
      id: shift.id,
      title: `$${Number(shift.guaranteedEarnings).toFixed(2)} — ${shift.status}`,
      start: stripZoneId(shift.startsAt),
      end: stripZoneId(shift.endsAt),
      classNames: [`shift-event-${String(shift.status).toLowerCase()}`]
    }));
  } catch (error) {
    console.error('Error fetching shifts for calendar:', error);
  }
};

onMounted(() => {
  fetchShifts();
});
</script>
